import React from "react";
import { Button } from "../../components/Button/Button";
import Footer from "../../components/Footer/Footer";
import Logo from "../../components/Logo/Logo";
import Navbar from "../../components/Navbar/Navbar";
import Text from "../../components/Text/Text";
import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      <Navbar />;
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="logo">
        <Logo />
      </div>
      <div className="text">
        <Text
          content={"Welcome to the FIFA WORLD CUP 2022"}
          textSize="txt--medium"
        />
      </div>
      <br />
      <div className="box">
        <div className="bet">
          <a
            href="https://www.winamax.fr/paris-sportifs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button label={"Make A Bet"} />
          </a>
        </div>
        <div className="discover">
          <a href="/country">
            <Button label={"Discover"} />
          </a>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default Home;
